import axios from "axios";
import { Get, Post } from "../server";

// 获取角色列表
export function getRoleList(data: any) {
  //Get方法用于向后台发送请求
  return Get("/admin/role/roles", data);
}

// 更新角色状态，启用，停用
export function updateRoleStatus(roleId: any, data: any) {
  //Get方法用于向后台发送请求
  return axios({
    url: `/admin/role/role/${roleId}/status`,
    method: "put",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("come-to-chant-token"),
    },
    data,
    baseURL: process.env.REACT_APP_BASE_URL,
  });
}

// 创建角色
export function createRole(params: any) {
  return Post("/admin/role/role", params);
}

// 删除角色
export function deleteRole(roleId: any) {
  //Get方法用于向后台发送请求
  return axios({
    url: `/admin/role/role/${roleId}`,
    method: "delete",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      Authorization: "Bearer " + localStorage.getItem("come-to-chant-token"),
    },
    baseURL: process.env.REACT_APP_BASE_URL,
  });
}

// 获取管理员列表
export function getAdminList(data: any) {
  //Get方法用于向后台发送请求
  return Get("/admin/role/admins", data);
}

// 更新管理员状态，启用，停用
export function updateAdminStatus(adminId: any, data: any) {
  //Get方法用于向后台发送请求
  return axios({
    url: `/admin/role/admin/${adminId}/status`,
    method: "put",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("come-to-chant-token"),
    },
    data,
    baseURL: process.env.REACT_APP_BASE_URL,
  });
}

// 创建管理员
export function createAdmin(params: any) {
  return Post("/admin/role/admin", params);
}

// 删除角色
export function deleteAdmin(adminId: any) {
  //Get方法用于向后台发送请求
  return axios({
    url: `/admin/role/admin/${adminId}`,
    method: "delete",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      Authorization: "Bearer " + localStorage.getItem("come-to-chant-token"),
    },
    baseURL: process.env.REACT_APP_BASE_URL,
  });
}

// 更新角色状态，启用，停用
export function updateRole(adminId: any, data: any) {
  //Get方法用于向后台发送请求
  return axios({
    url: `/admin/role/admin/${adminId}`,
    method: "put",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("come-to-chant-token"),
    },
    data,
    baseURL: process.env.REACT_APP_BASE_URL,
  });
}

// 更新角色状态，启用，停用
export function updateRoles(roleId: any, data: any) {
  //Get方法用于向后台发送请求
  return axios({
    url: `/admin/role/role/${roleId}`,
    method: "put",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("come-to-chant-token"),
    },
    data,
    baseURL: process.env.REACT_APP_BASE_URL,
  });
}

// 更新角色状态，启用，停用
export function updateRolesQ(roleId: any, data: any) {
  //Get方法用于向后台发送请求
  return axios({
    url: `/admin/role/role/${roleId}/authorities`,
    method: "put",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("come-to-chant-token"),
    },
    data,
    baseURL: process.env.REACT_APP_BASE_URL,
  });
}
